const _excluded = ["defaultValue", "disabled", "error", "fullWidth", "id", "label", "helperText", "maxLength", "onChange", "renderHelperText", "size", "rows", "value", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { useId } from "@react-aria/utils";
import { cx } from "../../helpers/utils/cx";
const textAreaStyles = {
  sm: "p-2 bolt-font-body-s-regular",
  md: "p-2 bolt-font-body-m-regular",
  lg: "p-3 bolt-font-body-m-regular"
};
const textAreaHeights = {
  sm: "h-20 min-h-comp-s",
  md: "h-28 min-h-comp-m",
  lg: "h-36 min-h-comp-l"
};
const states = {
  idle: "border-special-nulled focus:border-action-primary text-primary",
  disabled: "border-neutral-secondary cursor-not-allowed text-tertiary bg-special-nulled placeholder-tertiary",
  error: "border-danger-primary focus:border-danger-primary focus:shadow-inner text-primary caret-danger-primary"
};
export const TextArea = /*#__PURE__*/React.forwardRef(function RenderTextArea(props, ref) {
  const {
      defaultValue,
      disabled: isDisabled = false,
      error: hasError = false,
      fullWidth: isFullWidth = false,
      id,
      label,
      helperText,
      maxLength,
      onChange,
      renderHelperText = renderHelperTextDefault,
      size = "md",
      rows,
      value,
      required = false
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [textLength, setTextLength] = React.useState(value?.length ?? 0);
  const handleChange = React.useCallback(event => {
    setTextLength(event.target.value.length);
    onChange?.(event);
  }, [onChange]);
  const generatedId = useId();
  const textAreaId = id ?? `kalep-text-area-${generatedId}`;
  const helperTextId = `${textAreaId}-helper-text`;
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex-col flex gap-2", isFullWidth ? "w-full" : "w-96")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex justify-between")
  }, label && /*#__PURE__*/React.createElement("label", {
    className: cx("bolt-font-body-s-accent", required && "after:text-danger-primary after:content-['_*']", isDisabled ? " text-tertiary" : "text-primary"),
    htmlFor: textAreaId
  }, label), maxLength && /*#__PURE__*/React.createElement("span", {
    className: cx("bolt-font-body-tabular-s-regular text-secondary", isDisabled && "text-tertiary")
  }, textLength, "/", maxLength)), /*#__PURE__*/React.createElement("textarea", _extends({
    "aria-describedby": helperText ? helperTextId : undefined,
    "aria-invalid": hasError,
    className: cx("w-full resize-y", "border-2 rounded-md outline-none", "bg-neutral-secondary placeholder-secondary caret-action-primary", "ease-linear duration-100", "focus:bg-special-nulled", hasError && states.error, isDisabled && states.disabled, !isDisabled && !hasError && states.idle, isDisabled ? "cursor-not-allowed" : "cursor-text", textAreaStyles[size], rows === undefined && textAreaHeights[size]),
    disabled: isDisabled,
    id: textAreaId,
    maxLength: maxLength,
    onChange: handleChange,
    ref: ref,
    value: value,
    defaultValue: defaultValue,
    rows: rows
  }, rest)), renderHelperText(_objectSpread(_objectSpread({}, props), {}, {
    textAreaId,
    helperTextId
  }), renderHelperTextDefault));
});
function renderHelperTextDefault(_ref) {
  let {
    helperText,
    error,
    helperTextId,
    disabled
  } = _ref;
  if (!helperText) {
    return null;
  }
  return /*#__PURE__*/React.createElement("p", {
    className: cx("m-0 bolt-font-body-s-regular text-secondary", disabled && "text-tertiary", error && "text-danger-primary"),
    id: helperTextId
  }, helperText);
}